import { UserEnterpriseRoles } from 'enums/user-role';

/**
 * @name getRoleLevel
 * @description
 * Method that returns a level of the provided role
 */
export const getRoleLevel = (role) => UserEnterpriseRoles.indexOf(role);

/**
 * @name getMainRole
 * @description
 * Method that filters a list of role to find the main role.
 */
export const getMainRole = (roles = []) =>
  UserEnterpriseRoles.find((role) => roles.indexOf(role) >= 0);

/**
 * @name compareRolesLevel
 * @description
 * Method that returns the difference of levels between the roles.
 * If the first role is stronger the return value is positive, if the second role
 * is stronger the return value is negative, othewise the return value is 0.
 */
export const compareRolesLevel = (role1, role2) => getRoleLevel(role1) - getRoleLevel(role2);

export const isRoleStronger = (role, target) => compareRolesLevel(role, target) < 0;
export const isRoleStrongerOrEq = (role, target) => compareRolesLevel(role, target) <= 0;

export const isRoleWeaker = (role, target) => compareRolesLevel(role, target) > 0;
export const isRoleWeakerOrEq = (role, target) => compareRolesLevel(role, target) >= 0;
